import * as Yup from "yup";
import { isSwedishSocialSecurityNumber, isSwedishPhoneNumber } from "./validationService";

const baseUserSchema = {
  firstName: Yup.string(),
  lastName: Yup.string().trim().max(255),
  identityNumber: Yup.string()
    .required()
    .test("isValidIdentityNumber", (identityNumber?: string) => {
      if (!identityNumber || !identityNumber.length) return false;

      return isSwedishSocialSecurityNumber(identityNumber);
    }),
  email: Yup.string().email(),
  preferredCommunication: Yup.object().shape(
    {
      phone: Yup.boolean().when("email", {
        is: (email: boolean) => !email,
        then: Yup.bool().oneOf([true], "At least one needs to be checked"),
      }),
      email: Yup.boolean().when("phone", {
        is: (phone: boolean) => !phone,
        then: Yup.bool().oneOf([true], "At least one needs to be checked"),
      }),
    },
    [
      ["email", "phone"],
      ["phone", "email"],
    ]
  ),
  phoneNumber: Yup.string()
    .when("preferredCommunication.phone", {
      is: true,
      then: Yup.string().required(),
    })
    .test("isValidNumber", "Must be valid phonenumber", (phone?: string) => {
      if (!phone) return true;

      const isValid = isSwedishPhoneNumber(phone);
      return isValid;
    }),
};

const profileSchema = {
  ...baseUserSchema,
  avatarId: Yup.string(),
};

const newAccountSchema = {
  ...baseUserSchema,
  hasAcceptedAgreements: Yup.boolean().test("hasAcceptedAgreements", (hasAccepted?: boolean) => {
    if (hasAccepted === undefined) return false;
    return hasAccepted;
  }),
};

export const validationSchemaUserProfile: Yup.ObjectSchema<any> = Yup.object().shape(profileSchema);
export const validationSchemaUserNewUser: Yup.ObjectSchema<any> = Yup.object().shape(newAccountSchema);
